module.exports = __webpack_public_path__ + "images/0ff4faceed631a74f6e5d9c19095b439.png";